import { Map, Record, List } from 'immutable'
import {
  FETCH_NOTE_HISTORY_START,
  FETCH_NOTE_HISTORY_SUCCESS,
  FETCH_NOTE_HISTORY_ERROR,
} from './actionTypes'
import NoteHistoryRecord from './record'

const StatusRecord = Record({
  isLoading: false,
  hasError: false,
})

const InitialState = Record({
  status: Map(),
  map: Map(),
})

const notesHistoryReducer = (
  state = new InitialState(),
  { type, payload, meta }
) => {
  switch (type) {
    case FETCH_NOTE_HISTORY_START: {
      const { noteId } = meta.action.meta
      return state
        .setIn(['status', noteId], new StatusRecord({ isLoading: true }))
        .setIn(['map', noteId], new NoteHistoryRecord())
    }
    case FETCH_NOTE_HISTORY_SUCCESS: {
      const { noteId } = meta.action.meta
      return state
        .updateIn(['status', noteId], status => status.set('isLoading', false))
        .setIn(
          ['map', noteId],
          payload.reduce(
            (memo, rawHistory) => memo.push(new NoteHistoryRecord(rawHistory)),
            new List()
          )
        )
    }
    case FETCH_NOTE_HISTORY_ERROR: {
      const { noteId } = meta
      return state.updateIn(['status', noteId], status =>
        status.merge({ isLoading: false, hasError: true })
      )
    }
    default:
      return state
  }
}

export default notesHistoryReducer
